import React from "react";
import { Typography } from "@mui/material";

const Title = ({ text }) => {
  return <Typography>{text}</Typography>;
};

export default Title;
